import { Component, OnInit, OnDestroy, Input, Output, ViewChildren, QueryList } from '@angular/core';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators, AbstractControl } from '@angular/forms';

@Component({
  selector: 'checkbox-collectoin-component',
  templateUrl: './checkbox.collection.component.html'
})
export class CheckboxCollectionComponent implements OnInit, OnDestroy {
  @Input() prompt:string;
  @Input() tooltip:string;
  @Input() questionid:number;
  @Input() jsclassinit:any;
  @Input() value:any;
  @Input() questioninitmixin:any;
  @Input() disabled:boolean;
  @Input() required:boolean;

  validationMessages: any;
  formErrors:any;
  checkboxCollection:FormArray;
  labels:Array<string>;

  public getValue(){
    var v,result=[],value={};
    if(!this.disabled) {
      this.checkboxCollection.value.forEach((truefalse,i)=>{
        if(truefalse) {
          result.push(this.labels[i]);
        }
      });
      value[this.questionid]=result;
    } else {
      value[this.questionid]=null;
    }
    return value;
  }

  get noneSelected():boolean {
    return !this.checkboxCollection.value.some((item)=>{
      return item;
    });
  }

  isValid():boolean {
    if(this.disabled || !this.required) {
      return true;
    }
    return this.checkboxCollection.value.some((item)=>{
      return item;
    });
  }
  validate():boolean {
    this.checkboxCollection.markAsTouched();
    return this.isValid();
  }

  constructor() {
  }

  ngOnInit() {
    if(this.value===null) {
      this.value=Array();
    }
    this.checkboxCollection=new FormArray([]);
    if(!!this.questioninitmixin && !!this.questioninitmixin.items) {
      this.labels=this.questioninitmixin.items;
      this.questioninitmixin.items.forEach((item)=>{
        this.checkboxCollection.push(new FormControl(this.value.some((savedvalue)=>{
          return savedvalue==item;
        })));
      });
    }
  }

  ngOnDestroy() {
  }
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/questionnaire/elements/checkbox.collection.component.ts